/**
 * This class allows the user to customize the comparison tool with specific sub
 * column specification. Such specifications will be interpreted as Column Template
 * ({@link AbstractColumnTemplate}) for the {@link ReportTemplate}.
 *
 * @param {string} title - Title to use when generating a ColumnTemplate
 * @param {AbstractPeriodColumnTemplateSource} source - Represents where
 *   the column's data is coming from (e.g., actual accounting data or
 *   budget)
 * @param {AbstractDeviationType[]} [deviationTypes] - Specifies the types of
 *   deviation from actuals value for this particular sub column specification.
 *   Default is an empty array
 */
export class SubColumnSpec {
	constructor({ title, source, deviationTypes = [] }) {
		this._title = title;
		this._source = source;
		this._deviationTypes = deviationTypes;
	}

	getTitle() {
		return this._title;
	}

	getSource() {
		return this._source;
	}

	isActualsSpec() {
		return this._source.isActualsSource();
	}

	isForecastEstimateSpec() {
		return this._source.isForecastEstimateSource();
	}

	isBudgetSpec() {
		return this._source.isBudgetSource();
	}

	getDeviationTypes() {
		return this._deviationTypes;
	}

	hasDeviationType(candidate) {
		return this._deviationTypes.find((deviationType) =>
			deviationType.equals(candidate),
		);
	}

	addDeviationType(deviationType) {
		this._deviationTypes.push(deviationType);
	}

	removeDeviationType(deviationTypeToRemove) {
		this._deviationTypes = this._deviationTypes.filter(
			(deviationType) =>
				deviationType.getType() !== deviationTypeToRemove.getType(),
		);
	}
}
